module.exports = __webpack_public_path__ + "static/tiefling_wizard_mtg_afr-dfd4595d4f9ef55b05c32dc81128434f.jpg";